import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import {
  PaletteMode,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import { getTheme } from "./config/theme";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import { store } from "./store";
import { Toaster } from "./common/toaster";
import ReactQueryProvider from "./providers/ReactQueryProvider";

const theme = responsiveFontSizes(
  getTheme((localStorage.getItem("themeMode") as PaletteMode) || "light"),
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Toaster />
    <BrowserRouter basename="/contribute">
      <Provider store={store}>
        <ReactQueryProvider>
          <App />
        </ReactQueryProvider>
      </Provider>
    </BrowserRouter>
  </ThemeProvider>,
  // </React.StrictMode>,
);
